import cn from 'classnames'
import * as React from 'react'

import styles from './wave-container.module.scss'

export default function WaveContainer(props: React.HTMLAttributes<HTMLDivElement>) {
  const { className = '', children, ...rest } = props

  return (
    <div className={cn(styles.root, className)} {...rest}>
      {children}
    </div>
  )
}
